import * as yup from "yup";

const categoryValidation = yup.object().shape({
  name: yup.string().required("Bu alan zorunludur"),
});

export default categoryValidation;
